import axios from 'axios'
import * as bcrypt from 'bcryptjs'
import { http } from '../utilidades'

// auth.js módulo con todo el estado relacionado a los usuarios y la autenticación de la aplicación
export default {
  namespaced: true,
  state: {
    registro: [1, 2, 5],
    reporte: [1, 3, 5],
    current_user: '',
    users: {},
  },
  mutations: {
    // agrega un usuario al listado de usuarios
    agregarUsuario(state, usuario) {
      state.current_user = usuario.email
      state.users[usuario.email] = { ...usuario }
    },
    // vacía la información relacionada al usuario actual
    cerrarSesion(state) {
      state.registro = []
      state.reporte = []
      state.current_user = ''
      state.users = {}
    },
  },
  actions: {
    // verifica que las credenciales ingresadas sean correctas, de serlo agrega al usuario recibido por el backend (nombre, correo, hash) al state
    // para permitirle iniciar sesión posteriormente aunque no tenga conexión.
    async guardarUsers(context, users) {
      const response = await http({
        url: '/register',
        method: 'post',
        data: users
      })
      return response.data
    },

    async verifyCredentials(context, credenciales) {
      if (navigator.onLine) {
        try {
          const response = await http({
            url: '/login',
            method: 'post',
            data: {
              email: credenciales.email,
              password: credenciales.password,
            },
          })
          const success = response.data? response.data.success : false
          if (success) {
            this._vm.$sentry.configureScope((scope) => {
              scope.setUser({ email: credenciales.email })
            })
            context.commit('agregarUsuario', {
              name: response.data.name,
              email: response.data.email,
              password: response.data.password, // bcrypt hashed password
              role_id: response.data.role_id,
              authorized: response.data.authorized,
              avatar: response.data.avatar,
              token: response.data.token,
              id: response.data.id,
              id_institucion: response.data.id_institucion,
              id_agencia: response.data.id_agencia,
              cnameagru: response.data.cnameagru,
              permissions: response.data.permissions,
            })
          }
          return success
        } catch (e) {
          if (e.response.status === 401) {
            return false
          }
        }
      } else {
        // acceso sin conexión siempre y cuando el usuario haya accedido previamente
        if (
          Object.prototype.hasOwnProperty.call(
            context.state.users,
            credenciales.email
          )
        ) {
          const user = context.state.users[credenciales.email]
          if (bcrypt.compare(credenciales.password, user.password)) {
            context.commit('agregarUsuario', user)
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },

    async cerrarSesion({ commit }) {
      const response = await http({
        url: '/logout',
        method: 'get',
        params: {},
      })
      const success = response.data.success
      if (success) {
        commit('cerrarSesion')
        return success
      } else {
        return false
      }
    },

    async actualizarPassword(context, { actual, nueva, repetir_nueva }) {
      const response = await http({
        url: '/update-password',
        method: 'post',
        data: {
          actual,
          nueva,
          repetir_nueva,
        },
      })
      return response.data
    },
    async resetPassword(context, { email, token, nueva, repetir_nueva }) {
      const response = await http({
        url: '/resetPassword',
        method: 'post',
        data: {
          email,
          token,
          nueva,
          repetir_nueva,
        },
      })
      return response.data
    },
    async forgotPassword(context, { email, }) {
      const response = await http({
        url: '/forgotPassword',
        method: 'post',
        data: {
          email,
        },
      })
      return response.data
    },
    async verifyQuestions(context, { email, q1, q2, q3, q4, q5, q6, }) {
      const response = await http({
        url: '/verifyQuestions',
        method: 'post',
        data: {
          email,
          q1,
          q2,
          q3,
          q4,
          q5,
          q6,
        },
      })
      return response.data
    },
    

   /*  async logearsencillo(user) {
      // const email = user.email;
      //const password = user.password;
      const email = "";
      const password = "";
      const urlProduccion = 'https://localhost:8182/ciiepe/public/';
      try {
        const response = await axios.get(`${urlProduccion}validar/usuario/${email}/${password}`);
        if (response.data) {
          window.location.href = `${urlProduccion}dashboard`;
        } else {
          console.error("Credenciales incorrectas");
        }
      } catch (error) {
        console.error("Error al iniciar sesión:", error);
      }
    }, */

    ///// BACKEND /////////////////
    async logearCIIEPE(context, num) {
      /* var email = user.email
      var password = user.password
      var urlProduccion = 'http://10.253.177.70/ima/public/' */
      /////// OBTENER TOKEN ///////////////////////////
      if (navigator.onLine) {
          const payload = {
            num: num,
            windows_ios: 'Windows',
          }
          // const response = await this.Opera(payload)
          const response = await context.dispatch("Opera", payload);
          if (response && response.token) {
            //console.log("aqui TOKEN CIIEPE", response)
            // Guardar el token en cookies o localStorage
            const tokenB = response;
            //alert(tokenB)
            //document.cookie = `Authorization=Bearer ${token}; path=/`;
          /*   alert(document.cookie)
            console.log("AQUI IMPRIMIENDO LA COOKIE", document.cookie)
            window.location.href = `http://localhost:8182/#/ru/reportes/productor/productor-intermediario`;
            alert("envie documento con cookie") */
            return tokenB; // Éxito
          } else {
            console.error("Token no válido recibido:", response);
            return false; // Falla
          }
       
      }
    },

    async Opera(context, payload) {
      const { num, windows_ios } = payload;
      //alert('FUI A OPERA emailuser ' + num);
     
        const respuestita = await http({
          url: '/intero',
          method: 'post',
          data: {
            num,
            windows_ios,
          },
        });
        //alert('respuestita esta SI ' + respuestita)
        if (respuestita.data.token) {
          //alert('FUI A intero por el Token: ' + respuestita.data.token);
          //console.log(respuestita)
          return { token: respuestita };
        } else {
          //console.log("sin respuesta")
          //alert('La propiedad que dices tu no se encontró en la respuesta del otro servidor.');
        }
    
    },

    //NO SE USA
    /* async logearEnotroA(context, user) {
      const login = async () => {
        try {
          const response = await axios.post('https://monitor-cnc.org/suag/public/api/login', {
            email: "",
            password: ""
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
      
          console.log(response.data); // Aquí obtienes el token de la API de ciiepe
        } catch (error) {
          console.error("Error de login:", error);
        }
      };
      
      login();
       
      // Realizamos la solicitud GET al backend (Proyecto B)
      axios
        .get(urlProduccion + 'prueba/' + email + '/' + password)
        .then((resp) => {
          // Si la respuesta es exitosa, redirigimos al usuario
          if (resp.data && resp.data.success) { // Suponiendo que el backend responda con un campo `success`
            window.location.href = urlProduccion + 'productor-intermediario-ciudadano';
          } else {
            // Si no es exitosa, muestra un mensaje de error o lo que necesites
            console.error('Autenticación fallida');
          }
        })
        .catch((error) => {
          // Manejo de errores en caso de que falle la solicitud
          console.error('Error al autenticar:', error);
        });
    }, */
    
    async logearIMA(context, user) {
      var email = user.email
      var password = user.password
      var urlProduccion = 'http://10.253.177.70/ima/public/'

      axios
        .get(urlProduccion + 'validar/usuario/' + email + '/' + password)
        .then((resp) => {
          if (resp.data) {
            window.location.href = urlProduccion + 'dashboard'
          }
        })
    },


    async getUsers() {
      try {
        const users = (
          await http({
            url: '/users',
            method: 'get',
            params: {},
          })
        ).data
        return users
      } catch (error) {
        this.$sentry.captureException(error)
      }
    },
  },

  getters: {
    // retorna el usuario actual o un usuario con role -i si se encuentra vacío
    user: (state) => {
      return (
        state.users[state.current_user] || {
          name: '',
          email: '',
          password: '', // bcrypt hashed password
          role_id: [-1],
          authorized: '',
          avatar: '',
          token: '',
          id: '',
          id_institucion: '',
          cnameagru: '',
          permissions: [],
        }
      )
    },
    userCan: (state, getters) => (route) => {
      if (!Array.isArray(getters.user.permissions)) {
        return {
          browse: false,
          read: false,
          edit: false,
          add: false,
          delete: false,
        }
      }
      const b =
        getters.user.permissions
          .filter((p) => p.key === 'browse')
          .map((p) => p.table_name)
          .filter((p) => !!p)
          .filter((table) => route.includes(table)).length > 0
      const r =
        getters.user.permissions
          .filter((p) => p.key === 'read')
          .map((p) => p.table_name)
          .filter((p) => !!p)
          .filter((table) => route.includes(table)).length > 0
      const e =
        getters.user.permissions
          .filter((p) => p.key === 'edit')
          .map((p) => p.table_name)
          .filter((p) => !!p)
          .filter((table) => route.includes(table)).length > 0
      const a =
        getters.user.permissions
          .filter((p) => p.key === 'add')
          .map((p) => p.table_name)
          .filter((p) => !!p)
          .filter((table) => route.includes(table)).length > 0
      const d =
        getters.user.permissions
          .filter((p) => p.key === 'delete')
          .map((p) => p.table_name)
          .filter((p) => !!p)
          .filter((table) => route.includes(table)).length > 0

      return { browse: b, read: r, edit: e, add: a, delete: d }
    },
  },
}
